import { useCurrentUserFeatures } from '../../../shared/currentUser';

// https://abtesting.spotify.net/features/6701
export function useActivityPage() {
  const features = useCurrentUserFeatures();
  return features['s4a-activity-page'] === 'Rollout';
}
